import React from 'react';
import { api } from '../../../api';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { message, Input, Button, Divider } from 'antd';
import { UserOutlined, IdcardOutlined } from '@ant-design/icons';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { setUser } from 'actions/user';
import ModalChangePass from './ModalChangePass';
import '../styles.scss'

const FormItem = Form.Item;

class NormalLoginForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      disabledLogin: false,
      visibleCodigo: false
    }
  }
  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        this.setState({ disabledLogin: true });
        try {
          const response = await api.auth.login({ ...values });
          if (response.status === "success") {
            //      this.props.handleSetUser(response.data.clientes_autogestion);
            sessionStorage.setItem("token", response.data.token);
            this.props.history.push('/app/dashboard');
          } else {
            message.error(response.message, 7);
            this.setState({ disabledLogin: false });
          }
        } catch (e) {
          message.error("Verifique su conexión a internet", 7);
          this.setState({ disabledLogin: false });
        }
      }
    });
  }

  handleFirstLogin = async () => {
    const _this = this;
    this.setState({ disabledLogin: true })
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          const response = await api.auth.firstLogin({
            mail: values.usuario,
            documento: values.clave
          })
          if (response.status === "success") {
            message.success("Registrado con éxito")
            _this.setState({ disabledLogin: false })
            // Modal.info({
            //   title: 'Se le enviará un código a su dirección de correo electrónico',
            //   content: (
            //     <div>
            //       <p>Con el fin de activar su cuenta deberá ingresar el código recibido por mail</p>
            //       <p>Luego debe ingresar normalmente</p>
            //     </div>
            //   ),
            //   onOk() { _this.setState({ visibleCodigo: true, disabledLogin: false }) },
            // });
          } else {
            message.error(response.message)
            this.setState({ disabledLogin: false })
          }
        } catch (error) {
          message.error(error, 5)
          this.setState({ disabledLogin: false })
        }
      }
    });

  }

  handleChangePass = async () => {
    try {

    } catch (error) {
      message.error(error, 5)
    }
  }
  openChangePass = async () => {
    let usuario = this.props.form.getFieldValue('usuario') ? this.props.form.getFieldValue('usuario') : ''
    this.setState({ usuario, openModalChangePass: true })
  }

  render() {
    console.log("PROPS: ",this.props)
    const { getFieldDecorator } = this.props.form;
    return (
      <section className="form-v2-container">
        <h2>Bienvenido al Portal de Autogestión </h2>
        <Divider />
        <p className="lead">Ingrese a continuación su MAIL y DNI</p>
        <Form onSubmit={this.handleSubmit} className="form-v1">
          <FormItem>
            {getFieldDecorator('usuario', {
              rules: [{ required: true, message: 'Por favor ingrese su nombre de usuario!' }],
            })(
              <Input size="large" prefix={<UserOutlined />} placeholder="MAIL" />
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('clave', {
              rules: [{ required: true, message: 'Por favor ingrese su documento!' }],
            })(
              <Input size="large" prefix={<IdcardOutlined />} placeholder="DOCUMENTO" />
            )}
          </FormItem>

          {/* {this.state.visibleCodigo &&
            <FormItem>
              {getFieldDecorator('codigo', {
                rules: [{ required: false, message: 'Por favor ingrese su contraseña!' }],
              })(
                <Input size="large" prefix={<IssuesCloseOutlined />} placeholder="CÓDIGO" />
              )}
            </FormItem>
          } */}

          <FormItem>
            <Button type="primary" htmlType="submit" className="btn-cta btn-block" disabled={this.state.disabledLogin}>
              INGRESAR
            </Button>
          </FormItem>
          {/* <Button type="danger" className="btn-cta btn-block" onClick={this.handleFirstLogin} disabled={this.state.disabledLogin}>
            Ingreso por primera vez
          </Button> */}
          {/* <Button type="default" className="btn-cta btn-block" onClick={this.openChangePass} disabled={this.state.disabledLogin}>
            Olvidé mi contraseña
          </Button> */}
        </Form>
        {this.state.openModalChangePass &&
          <ModalChangePass
            closeModal={() => {
              this.setState({ openModalChangePass: false });
            }}
            mail={this.state.usuario}
          />

        }
      </section>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(withRouter(NormalLoginForm));

const mapStateToProps = state => ({
  config: state.config,
});

const mapDispatchToProps = (dispatch) => {
  console.log("dispatch 2: ", dispatch);
  return {
    handleSetUser: (user) => {
      dispatch(setUser(user));
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedNormalLoginForm);
